(function(window, $, templates, playerConfiguration, quizController, localizationStrings, viewHelper, deviceInfo, IoOverlayView, responsiveController, highlightDisabler, events) {
   'use strict';

   window.TSC = window.TSC || {};
   window.TSC.imageView = (function() {
      var _$container;

      // vars to hold jq elements
      var _imageDiv;
      var _quizBar;
      var _imageWrapper;

      var _animating = false;
      var _animationSpeed = 300;
      var _clickToTakeTheQuiz = localizationStrings.strings.accessBtnTakeQuiz;
      var _txtHideQuiz = localizationStrings.strings.accessBtnHideQuiz;
      var _txtShowQuiz = localizationStrings.strings.accessBtnShowQuiz;
      var _txtHideAnswer = localizationStrings.strings.accessBtnHideAnswer;
      var _txtShowAnswer = localizationStrings.strings.accessBtnShowAnswer;
      var _imageNotFound = localizationStrings.strings.mediaNotFound;

      var _defaultMarkup = templates.image_view_template({clickToTakeTheQuiz: _clickToTakeTheQuiz});
      var _eventCategory = 'Image';

      var _showQuizEventListeners = [];
      var _hideQuizEventListeners = [];
      var _showQuiz = false;
      var _quizBarShowingAnswers = false;
      var _submitting = false;
      var _loaded = false;
      var _minScale = 1;
      var _ioOverlayView;

      var setBackgroundImage = function(image, imageDisplayedCallback) {
         _imageDiv.bind('error', function() {
            _ioOverlayView.displayMessage(_imageNotFound, true);
            _imageDiv.hide();
         });
         _imageDiv.load(setupPanAndZooming);
         _imageDiv.attr('src', image);

         processPlayerEvent('Content_Loaded', _eventCategory, image);
         if (imageDisplayedCallback) {
            imageDisplayedCallback();
         }
      };

      var getMediaRotationDegrees = function() {
         if (!deviceInfo.isIOS()) {
            return playerConfiguration.getMediaRotation();
         }
      };

      var calculateMinScale = function() {
         var minScale = 1;
         var mediaRotationDegrees = getMediaRotationDegrees();
         if (mediaRotationDegrees === 90 || mediaRotationDegrees === 270) {
            if (_imageDiv.width() > _imageDiv.height()) {
               if (_imageDiv.width() > _imageWrapper.height()) {
                  minScale = _imageWrapper.height() / _imageDiv.width();
               }
            } else if (_imageDiv.height() > _imageWrapper.width()) {
               minScale = _imageWrapper.width() / _imageDiv.height();
            }
         }
         return minScale;
      };

      var setupPanAndZooming = function() {
         _loaded = true;

         _imageDiv.panzoom('resetDimensions');

         // Image panning and zooming, modified from https://github.com/timmywil/jquery.panzoom/blob/master/demo/index.html
         var nativeScale = this.naturalWidth / this.clientWidth;

         _minScale = calculateMinScale();

         _imageDiv.panzoom({minScale: _minScale, maxScale: 200, rotate: getMediaRotationDegrees()});
         _imageDiv.panzoom('zoom', _minScale, {animate: false});

         // scroll zoom in / out
         _imageWrapper.on('mousewheel.focal DOMMouseScroll', function(mouseWheelEvent) {
            mouseWheelEvent.preventDefault();
            var delta = mouseWheelEvent.delta || mouseWheelEvent.originalEvent.wheelDelta || mouseWheelEvent.originalEvent.detail * -1;
            var zoomOut = delta ? delta < 0 : mouseWheelEvent.originalEvent.deltaY > 0 || mouseWheelEvent.originalEvent.detail > 0;
            // Firefox fix
            if (!mouseWheelEvent.clientX) {
               mouseWheelEvent.clientX = mouseWheelEvent.originalEvent.clientX;
               mouseWheelEvent.clientY = mouseWheelEvent.originalEvent.clientY;
            }
            _imageDiv.panzoom('zoom', zoomOut, {
               focal: mouseWheelEvent
            });
         });

         _imageDiv.on('panzoomzoom', function(zoomEvent, panzoom, scale) {
            _imageDiv.panzoom('option', 'increment', scale * 0.1);
            setZoomInOrOutCursor();
         });


         _imageDiv.on('panzoomend', function(zoomEvent, panzoom, matrix, changed) {
            var zoomEndNativeScale = this.naturalWidth / this.clientWidth;
            if (!changed) {
               if (zoomEndNativeScale === 1 || matrix[0] > 1) {
                  _imageDiv.panzoom('zoom', _minScale, {focal: zoomEvent, animate: true});
                  _imageDiv.css('cursor', 'zoom-in');
               } else {
                  _imageDiv.panzoom('zoom', nativeScale, {focal: zoomEvent, animate: true});
               }
            }
         });

         _imageDiv.css('cursor', 'zoom-in');

         _$container.on('resize', onContainerResize);
      };

      var onContainerResize = function() {
         if (_showQuiz) {
            _imageWrapper.width('calc(100% - ' + getOffset() + 'px)');
         } else {
            _imageWrapper.width('100%');
         }
         _imageDiv.panzoom('resetDimensions');
         _imageDiv.panzoom('reset', {animate: false});
         _minScale = calculateMinScale();
         _imageDiv.panzoom('zoom', _minScale, {animate: false});
         responsiveController.manageResponsiveClasses();
      };

      var setZoomInOrOutCursor = function() {
         if (_imageDiv.panzoom('getMatrix')[0] > 1) {
            _imageDiv.css('cursor', 'zoom-out');
         } else {
            _imageDiv.css('cursor', 'zoom-in');
         }
      };

      var initDom = function($container) {
         _$container = $container;
         _$container.html(_defaultMarkup);
         _$container.fadeIn(_animationSpeed);
         $('body').css('background-color', 'transparent');

         _imageWrapper = $('#imageWrapper');
         _imageDiv = $('#imageDiv');
         _quizBar = $('#quizBar');
         _ioOverlayView = IoOverlayView.create($container);
         _quizBar.bind('click', toggleQuizBar);

         $container.on('mousedown', '*', function(e) {
            var $this = $(this);
            if (($this.is(':focus') || $this.is(e.target)) && !$this.is('input')) {
               highlightDisabler.disableHighlights($this);
            }
         });

         responsiveController.monitorContainerSize(_$container);

         setTimeout(function() {
            if (viewHelper.elementOrChildHasFocus(_$container)) {
               _quizBar.focus();
               highlightDisabler.disableHighlights(_quizBar);
            }
         }, 100);
      };

      var processPlayerEvent = function(action, label, value) {
         if (playerConfiguration.getCustomEventTracking()) {
            if (playerConfiguration.getCustomEventCallback()) {
               if (playerConfiguration.getAltEventCategoryAsFilename()) {
                  playerConfiguration.getCustomEventCallback().call(this, {category: playerConfiguration.getMediaFileName(), action: action, label: label, value: value});
               } else {
                  playerConfiguration.getCustomEventCallback().call(this, {category: _eventCategory, action: action, label: label, value: value});
               }
            }
         }

         if (playerConfiguration.getGoogleAnalyticsID()) {
            window._gaq.push(['_trackEvent', _eventCategory, action, label]);
         }
      };

      var toggleQuizBar = function() {
         if (_submitting || !_loaded) {
            return;
         }

         if (!_animating) {
            _imageDiv.addClass('imageDiv-animation-style');
            _animating = true;
         }

         if (_quizBarShowingAnswers) {
            if (_showQuiz) {
               _quizBar.html(_txtShowAnswer);
               hideQuiz();
            } else {
               _quizBar.html(_txtHideAnswer);
               showQuiz();
            }
         } else if (_showQuiz) {
            _quizBar.html(_txtShowQuiz);
            hideQuiz();
         } else {
            _quizBar.html(_txtHideQuiz);
            showQuiz();
         }
      };

      var getOffset = function() {
         if (_$container.height() <= 400) {
            return 0;
         }
         if (_$container.width() <= 720) {
            return 285;
         }
         return 300;
      };

      var calculateAspectRatioFit = function(srcWidth, srcHeight, maxWidth, maxHeight) {
         var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
         return {width: srcWidth * ratio, height: srcHeight * ratio};
      };

      var offsetImage = function(moveLeft) {
         var matrix = _imageDiv.panzoom('getMatrix');
         var offset = moveLeft ? getOffset() * -1 : getOffset();
         if (matrix[0] === _minScale) {
            var parentWidth = _imageWrapper.width() + offset;
            var parentHeight = _imageWrapper.height();

            var dimensions = calculateAspectRatioFit(_imageDiv.width(), _imageDiv.height(), parentWidth, parentHeight);

            if (_imageDiv[0].naturalWidth <= parentWidth && _imageDiv[0].naturalHeight <= parentHeight) {
               dimensions.width = _imageDiv[0].naturalWidth;
               dimensions.height = _imageDiv[0].naturalHeight;
            }

            var x = Math.min((parentWidth - dimensions.width) / 2);
            var y = Math.min((parentHeight - dimensions.height) / 2);
            _imageDiv.panzoom('pan', x, y);
         }

         _imageWrapper.one('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function() {
            _imageDiv.panzoom('resetDimensions');
            if (matrix[0] === _minScale) {
               _imageDiv.panzoom('reset', {animate: false});
               _imageDiv.panzoom('zoom', _minScale, {animate: false});
               _imageDiv.css('cursor', 'zoom-in');
            }
         });
      };

      var showQuiz = function() {
         offsetImage(true);
         _imageWrapper.width('calc(100% - ' + getOffset() + 'px)');
         $.each(_showQuizEventListeners, function(index, callback) {
            callback();
         });
         _showQuiz = true;
      };

      var hideQuiz = function() {
         offsetImage(false);
         _imageWrapper.width('100%');
         $.each(_hideQuizEventListeners, function(index, callback) {
            callback();
         });
         _showQuiz = false;
      };

      var showSubmitting = function() {
         _quizBar.html('');
         _submitting = true;
         $('#quiz_content').hide();
         $('#tsc_submitting').show();
      };

      var hideSubmitting = function() {
         _quizBar.html(_txtHideAnswer);
         _submitting = false;
         _quizBarShowingAnswers = true;
      };

      return {
         initView: function($container, imageSrc, imageDisplayedCallback) {
            quizController.mediaIsImage = true;
            initDom($container);
            setBackgroundImage(imageSrc, imageDisplayedCallback);
         },
         showQuizBar: function() {
            _imageWrapper.height('calc(100% - 40px');
            _quizBar.show();
         },
         initEvents: function() {
            this.addEventListener('SHOW_QUIZ', quizController.showQuiz);
            this.addEventListener('HIDE_QUIZ', quizController.hideQuiz);
            _$container.on(events.Quizzing.Status, showSubmitting);
            _$container.on(events.Quizzing.TransitionImageQuizToAnswers, hideSubmitting);
            _$container.on(events.Quizzing.ShowQuizBar, this.showQuizBar);
            _$container.on(events.Quizzing.HideQuiz, toggleQuizBar);
         },
         addEventListener: function(type, listener) {
            if (listener && typeof listener === 'function') {
               if (type === 'SHOW_QUIZ') {
                  _showQuizEventListeners.push(listener);
               } else if (type === 'HIDE_QUIZ') {
                  _hideQuizEventListeners.push(listener);
               } else {
                  throw new Error('image-view.js: addEventListener() Type argument was not SHOWQUIZ or HIDEQUIZ');
               }
            } else {
               throw new Error('image-view.js: addEventListener() Listener argument was not a function');
            }
         }
      };
   }());
})(this, window.jQuery, window.TSC.templates, window.TSC.playerConfiguration, window.TSC.quizController, window.TSC.localizationStrings, window.TSC.viewHelper, window.TSC.deviceInfo, window.TSC.IoOverlayView, window.TSC.responsiveController, window.TSC.highlightDisabler, window.TSC.events);
